var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistorico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9091 10.9412H19.2727V12.6176H12.9091V10.9412ZM12.9091 8.14706H19.2727V9.82353H12.9091V8.14706ZM12.9091 13.7353H19.2727V15.4118H12.9091V13.7353ZM20.1818 2H3.81818C2.81818 2 2 3.00588 2 4.23529V18.7647C2 19.9941 2.81818 21 3.81818 21H20.1818C21.1818 21 22 19.9941 22 18.7647V4.23529C22 3.00588 21.1818 2 20.1818 2ZM20.1818 18.7647H12V4.23529H20.1818V18.7647Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistorico);
export default __webpack_public_path__ + "static/media/historico.c98d9014b8080f50d996dd2eea2bc51b.svg";
export { ForwardRef as ReactComponent };